/* check the user's location, show nagbar if in canada */

jQuery.ajax( {
  url: '//freegeoip.net/json/',
  type: 'POST',
  dataType: 'jsonp',
  success: function(loc) {
    var CANADA = ['CA', 'CAN'];
    var UNITEDSTATES = ['US', 'USA'];
    var $nag_canada = $('.nagbar-canada');
    var $nag_other = $('.nagbar-other');
    var country     = (loc.country_code || '').toUpperCase();
    var is_canada   = CANADA.indexOf(country) > -1;
    var is_us       = UNITEDSTATES.indexOf(country) > -1;
    var is_other    = !is_canada && !is_us;

    if(!!is_canada){
    	$('em', $nag_canada).css('display', 'none');
      $('em.' + country.substr(0,2).toLowerCase(), $nag_canada).show();
      $nag_canada.show('fast');
    } else if(!!is_other){
    	$('em', $nag_other).css('display', 'none');
      $('em.' + country.substr(0,2).toLowerCase(), $nag_other).show();
      $nag_other.show('fast');
    }
  }
});
